/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ContactDefs from './defs.defs.js'

const $nsid = 'app.bsky.contact.getSyncStatus'

export { $nsid }

/** Gets the user's current contact import status. Requires authentication. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    syncStatus: l.optional(
      l.ref<ContactDefs.SyncStatus>((() => ContactDefs.syncStatus) as any),
    ),
  }),
  ['InvalidDid', 'InternalError'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
